import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as types from './types';
import * as api from './api';

export const connectMobileDevice = createApiAction(
  types.MOBILE_DEVICE_CONNECT,
  ({ deviceSessionId, elementId }) => api.connectDevice({ deviceSessionId, elementId }),
  { meta: { skipErrorPage: true } },
);

export const disconnectMobileDevice = createAction(types.MOBILE_DEVICE_DISCONNECT);

export const updateMobileDeviceState = createAction(types.MOBILE_DEVICE_STATE_UPDATE);
